import axios from "axios";
import {SomlStatusTask, StatusTaskOperation, StatusType} from "../types/Status";
import BaseService from "./base-service";
import * as Endpoints from './endpoints';

export type SomlStatusResponse = {
  tasks: Array<SomlStatusTask>
}

/**
 * Service for retrieving the status of SOML services.
 */
export default class SomlStatusService extends BaseService {

  /**
   * Retrieves the current SOML status from the semantic object service.
   *
   * @param {StatusType} statusType is the type of status to retrieve
   * @return {Promise<SomlStatusResponse>}
   */
  public static getSoaasSomlStatus(statusType: StatusType): Promise<SomlStatusResponse> {
    const url = `${Endpoints.SOML_STATUS}/${statusType}`;
    return axios.get(url)
      .then(this.resolveResponse)
      .then(this.resolveSomlStatusResponse)
      .catch(this.resolveErrorResponse);
  }

  /**
   * Retrieves the current SOML status from the Search service.
   *
   * @param {StatusType} statusType is the type of status to retrieve
   * @return {Promise<SomlStatusResponse>}
   */
  public static getSearchSomlStatus(statusType: StatusType): Promise<SomlStatusResponse> {
    const url = `${Endpoints.SEARCH_STATUS}/${statusType}`;
    return axios.get(url)
      .then(this.resolveResponse)
      .then(this.resolveSomlStatusResponse)
      .catch(this.resolveErrorResponse);
  }

  private static resolveSomlStatusResponse(responseData: any): SomlStatusResponse {
    return {
      tasks: responseData.data.map(SomlStatusService.resolveTaskData)
    };
  }

  private static resolveTaskData(taskData: { id: string, duration: number, operation: string, subOperation: any }): SomlStatusTask {
    return {
      id: taskData.id,
      duration: taskData.duration,
      operation: (StatusTaskOperation as any)[taskData.operation],
      subOperations: taskData.subOperation ? taskData.subOperation.map(SomlStatusService.resolveTaskData) : []
    };
  }
}
